import {
  API_ERROR,
  DEPARTMENTS,
  DEPARTMENT_LIST_SUCCESSFUL,
  DEPARTMENT_ADD,
  DEPARTMENT_ADD_SUCCESSFUL,
  DEPARTMENT_EDIT,
  DEPARTMENT_EDIT_SUCCESSFUL,
  DEPARTMENT_DELETE,
  DEPARTMENT_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
} from "./actionTypes";

export const getDepartments = () => {
  return {
    type: DEPARTMENTS,
  };
};

export const departmentListSuccessful = (departments) => {
  return {
    type: DEPARTMENT_LIST_SUCCESSFUL,
    payload: departments,
  };
};

export const departmentAdd = (department, history) => {
  return {
    type: DEPARTMENT_ADD,
    payload: { department, history },
  };
};

export const departmentAddSuccessful = (response) => {
  return {
    type: DEPARTMENT_ADD_SUCCESSFUL,
    payload: response,
  };
};

export const departmentEdit = (data) => {
  return {
    type: DEPARTMENT_EDIT,
    payload: data,
  };
};

export const departmentEditSuccessful = (response) => {
  return {
    type: DEPARTMENT_EDIT_SUCCESSFUL,
    payload: response,
  };
};

export const departmentDelete = (deptId, history) => {
  return {
    type: DEPARTMENT_DELETE,
    payload: { deptId, history },
  };
};

export const SetEditData = (data) => {
  return {
    type: DEPARTMENT_SETROWDATA,
    payload: data,
  };
};

export const model_open = () => {
  return {
    type: MODEL_OPEN,
  };
};

export const model_close = () => {
  return {
    type: MODEL_CLOSE,
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
